import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { CalendarCheck } from 'lucide-react';

const StickyMobileCTA = ({ onBookClick }) => {
  const { isRTL } = useLanguage();

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 px-4 pb-5 pt-3 bg-gradient-to-t from-charcoal via-charcoal/95 to-transparent pointer-events-none">
      <button
        onClick={onBookClick}
        className="pointer-events-auto w-full flex items-center justify-center gap-2.5 py-4 bg-gold text-charcoal text-sm uppercase tracking-wider font-semibold rounded-xl shadow-[0_-2px_24px_rgba(0,0,0,0.4)] active:scale-[0.98] transition-transform"
      >
        <CalendarCheck size={17} className="text-charcoal" />
        <span>{isRTL ? 'احجزي جلسة' : 'Book a Session'}</span>
      </button>
    </div>
  );
};

export default StickyMobileCTA;
